/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["h2[_ngcontent-%COMP%]{font-weight:500}.btn-container[_ngcontent-%COMP%]{margin-bottom:20px;display:flex;justify-content:flex-end}.btn-container[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{padding:0 40px;font-size:12px;color:#f1c400;background:#434343;border-color:#434343}.row-head[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{background:#434343;color:#f1c400;font-weight:700;text-transform:uppercase}.row-state[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{background:#fff}"];
export { styles as styles };
